export default () => {
	const cookieBanner = document.getElementById('cookie-banner');

	if (!cookieBanner) return;

	const barHeight = cookieBanner.scrollHeight;
	const acceptButton = document.getElementById('cookie-banner-accept');

	cookieBanner.style.bottom = -barHeight + 'px';
	cookieBanner.style.top = '';
	cookieBanner.classList.add('visible');

	setTimeout(()=> {
		cookieBanner.style.bottom = 0 + 'px';
	}, 1000);

	function setCookie(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

	acceptButton.addEventListener('click', () => {
		cookieBanner.style.bottom = -barHeight + 'px';
		setCookie('accpcookie', '1' , '90');
		setTimeout(()=> {
			cookieBanner.remove();
		}, 850);
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/cookie-bar.js